import { Employees } from '~/data/employees';
import { VacantionBalancesReportData } from '~/data/reports';

export type VacationBalancesReportRow_Employee = {
  employeeId: number;
  firstName: string;
  lastName: string;
  employeeNumber: string;
};

export type VacationBalancesReportRow_Position = {
  organizationUnit: string;
  organizationUnitNumber: string;
  costCenter: string;
  costCenterCode: string;
  legalEntity: string;
  legalEntityCode: string;
  managerNumber: string;
  manager: string;
};

export type VacationBalancesReportRow_VacationBalance = {
  balance: number;
  approved: number;
  inProgress: number;
  remainingBalance: number;
};

export type VacationBalancesReportRow_ExtraVacationBalance = {
  extraBalance: number;
  extraBalanceApproved: number;
  extraBalanceInProgress: number;
};

export type VacationBalancesReportRow_SuplementalBalance1 = {
  supplementalBalance1: number;
  supplementalSpent1: number;
};

export type VacationBalancesReportRow_SuplementalBalance2 = {
  supplementalBalance2: number;
  supplementalSpent2: number;
};

export type VacationBalancesReportRow_VacationBank1 = {
  bank1Balance: number;
  bank1BalanceApproved: number;
  bank1BalanceInProgress: number;
};

export type VacationBalancesReportRow_VacationBank2 = {
  bank2Balance: number;
  bank2BalanceApproved: number;
  bank2BalanceInProgress: number;
};

export type VacationBalancesReportRow_VacationBank3 = {
  bank3Balance: number;
  bank3BalanceApproved: number;
  bank3BalanceInProgress: number;
};

export type VacationBalancesReportRow = {
  rowId: string;
} & VacationBalancesReportRow_Employee &
  VacationBalancesReportRow_Position &
  VacationBalancesReportRow_VacationBalance &
  VacationBalancesReportRow_ExtraVacationBalance &
  VacationBalancesReportRow_SuplementalBalance1 &
  VacationBalancesReportRow_SuplementalBalance2 &
  VacationBalancesReportRow_VacationBank1 &
  VacationBalancesReportRow_VacationBank2 &
  VacationBalancesReportRow_VacationBank3;

export const convertVacationBalancesReportDataToRows = (props: {
  data: VacantionBalancesReportData[];
  getEmployeeById: (employeeId?: number) => Employees | undefined;
}): VacationBalancesReportRow[] => {
  const { data, getEmployeeById } = props;

  return data.map((entry, index): VacationBalancesReportRow => {
    const {
      fEmpId,
      fEmpNum,
      fEmpFirstName,
      fEmpLastName,
      fEmpUnit,
      fEmpUnitNumber,
      fEmpManagerId,
      fEmpLegalEntityName,
      fEmpLegalEntityCode,
      fEmpCostCenterName,
      fEmpCostCenterCode,
      fEmpVacationDetails,
    } = entry;

    const managerDetails = getEmployeeById(fEmpManagerId);
    const managerFullName = managerDetails
      ? `${managerDetails.fEmpFirstName} ${managerDetails.fEmpLastName}`
      : '';

    const vacationDetail = fEmpVacationDetails[0];

    return {
      rowId: `${fEmpId}-${index}`,
      employeeId: fEmpId,
      firstName: fEmpFirstName,
      lastName: fEmpLastName,
      employeeNumber: fEmpNum,
      organizationUnit: fEmpUnit,
      organizationUnitNumber: fEmpUnitNumber,
      legalEntity: fEmpLegalEntityName,
      legalEntityCode: fEmpLegalEntityCode,
      costCenter: fEmpCostCenterName,
      costCenterCode: fEmpCostCenterCode,
      managerNumber: managerDetails?.fEmpPersonNumber ?? '',
      manager: managerFullName,
      balance: vacationDetail?.fEmpVacationBalance,
      approved: vacationDetail?.fEmpVacationBalanceApproved,
      inProgress: vacationDetail?.fEmpVacationBalanceInProgress,
      remainingBalance: vacationDetail?.fEmpRemainingVacationBalance,
      extraBalance: vacationDetail?.fEmpVacationBalanceExtra,
      extraBalanceApproved: vacationDetail?.fEmpVacationBalanceExtraApproved,
      extraBalanceInProgress:
        vacationDetail?.fEmpVacationBalanceExtraInProgress,
      supplementalBalance1: vacationDetail?.fEmpVacationBalanceSuppl1,
      supplementalSpent1: vacationDetail?.fEmpVacationBalanceSuppl1Spent,
      supplementalBalance2: vacationDetail?.fEmpVacationBalanceSuppl2,
      supplementalSpent2: vacationDetail?.fEmpVacationBalanceSuppl2Spent,
      bank1Balance: vacationDetail?.fEmpVacationBalanceBank1,
      bank1BalanceApproved: vacationDetail?.fEmpVacationBalanceBank1Approved,
      bank1BalanceInProgress:
        vacationDetail?.fEmpVacationBalanceBank1InProgress,
      bank2Balance: vacationDetail?.fEmpVacationBalanceBank2,
      bank2BalanceApproved: vacationDetail?.fEmpVacationBalanceBank2Approved,
      bank2BalanceInProgress:
        vacationDetail?.fEmpVacationBalanceBank2InProgress,
      bank3Balance: vacationDetail?.fEmpVacationBalanceBank3,
      bank3BalanceApproved: vacationDetail?.fEmpVacationBalanceBank3Approved,
      bank3BalanceInProgress:
        vacationDetail?.fEmpVacationBalanceBank3InProgress,
    };
  });
};
